import {
  classes,
  HEIGTH_HALF,
  selectors } from '@/behaviour/header_navigation/variables'
import { $ } from '@/libs/jquery/index'

export class HeaderCategories {

  private selectors: ISelectors = selectors
  private classes: IClasses = classes

  private base: JQuery | null = null
  private more: JQuery | null = null

  public constructor() {
    this.base = $(this.selectors.base).find(this.selectors.filtersWrapper)
    if (this.base.length) {
      this.init()
    }
  }

  // раскрыли - раскрыли
  // закрыли - закрыли
  //  панель не должна влиять

  private init(): void {
    // инициилизируем работу категорий
    this.initCategory()
  }

  // инициилизируем работу категорий
  private initCategory(): void {
    // считаем, есть ли у нас кнопка More
    const height: number = this.base.find(this.selectors.listCategories).height()
    // убираем overflow, чтобы можно было показать подменю по hover
    this.base.removeClass(this.classes.overflowHidden)
    if (height === HEIGTH_HALF ) {
      this.base.find(this.selectors.more).hide()
    } else {
      // убрали overflow, значит, нужно спрятать то, что выглядывает снизу
      this.hideMenuPoints()
      this.more = this.base.find(this.selectors.more)
      // так как море есть, то вешаем событие на море
      this.initMoreListener()
      // проверяем, не нужно ли сразу раскрыть меню
      this.checkIsActiveMenu()
    }
  }

  // вешаем событие на море
  private initMoreListener(): void {
    this.base
      .on('click', this.selectors.more, () => this.toggleMenu())
  }

  // раскрываем или закрываем меню
  private toggleMenu(): void {
    const heightMenu: number = this.base.height()
    if (heightMenu === HEIGTH_HALF ) {
      // раскрываем
      this.base
        .addClass(this.classes.filtersAuto)
        .find(`.${this.classes.jsMenuMore}`).removeClass(this.classes.jsMenuMoreHidden)
      this.more.addClass(this.classes.active)
    } else {
      // закрываем
      this.base
        .removeClass(this.classes.filtersAuto)
        .find(`.${this.classes.jsMenuMore}`).addClass(this.classes.jsMenuMoreHidden)
      this.more.removeClass(this.classes.active)
    }
  }

  // проверяем, не нужно ли сразу раскрыть меню
  private checkIsActiveMenu() {
    const activeElem: JQuery = this.base.find(`.${this.classes.active}`)
    if (activeElem.length > 0) {
      const isBoundedEquals: boolean = (this.base[0].getBoundingClientRect().bottom ===
        activeElem[0].getBoundingClientRect().bottom)
      if (!isBoundedEquals) {
        this.base
          .addClass(this.classes.filtersAuto)
          .find(`.${this.classes.jsMenuMore}`).removeClass(this.classes.jsMenuMoreHidden)
        this.more.addClass(this.classes.active)
      }
    }
  }

  // прячем пункты, которые потом будем раскрывать по more
  private hideMenuPoints() {
    const filterBottom = this.base[0].getBoundingClientRect().bottom

    const items = this.base.find(this.selectors.filtersItem).filter((item, elem) => {
      return filterBottom !== elem.getBoundingClientRect().bottom
    })
    items.addClass(`${this.classes.jsMenuMoreHidden} ${this.classes.jsMenuMore}`)
  }
}
